import { trustItems } from '../../data/homepageData';
import { IconBadge } from '../ui/IconBadge';

export function TrustStrip() {
  return (
    <section id="trust" className="trust-strip" aria-label="Hlavní výhody">
      {trustItems.map((item) => <IconBadge key={item.title} {...item} />)}
    </section>
  );
}
